import { AudioManager } from '@game-libs/audio-manager';
import { CONFIG } from '../../config';
import { GameplayEvents } from '../../types/game-events';
import { GUIGameState } from '../../types/game-types';
import { EventsManager } from '@game-libs/events-manager';
import { useGameStatusStore } from '../zustand/useGameStatusStore';

export const manageStunEffectReducer = (state: GUIGameState, addStun = false) => {
  const currentStun = useGameStatusStore.getState().stunEffectTickDurationRemaining;
  const stunAmount = addStun ? CONFIG.game.stunEffectTotalTickDuration : currentStun - 1000;

  if (stunAmount <= 0) {
    const { emit } = EventsManager();
    const { playSFX } = AudioManager();

    emit(GameplayEvents.UNSTUN_UNITS);
    playSFX('unstun');
  }

  useGameStatusStore.getState().setStunEffectTickDurationRemaining(Math.max(0, stunAmount));

  return state;
};
